<template>
  <ModalProvider id="modalFactura" ref="modalFactura" :is-form="true" @submit="agregarFactura">
    <template #title>
      {{ factura.id == null ? 'Nueva Factura' : 'Editar Factura' }}
    </template>
    <template #body>
      <div class="form-group">
        <label :class="{ 'text-danger': hasError(factura.errors.fecha_documento) }">
          Fecha Documento
        </label>
        <InputDatePicker
          v-model="factura.fecha_documento"
          :only-current-month="true"
          :has-error="hasError(factura.errors.fecha_documento)"
          :clearable="true"
        />
        <small v-if="hasError(factura.errors.fecha_documento)" class="form-text text-danger">
          {{ factura.errors.fecha_documento[0] }}
        </small>
      </div>
      <div class="row">
        <div class="col-6">
          <InputProvider
            v-model="factura.serie"
            label="Serie:"
            :has-error="hasError(factura.errors.serie)"
            :error-message="hasError(factura.errors.serie) ? factura.errors.serie[0] : ''"
          />
        </div>
        <div class="col-6">
          <InputProvider
            v-model="factura.documento"
            label="# Factura:"
            :has-error="hasError(factura.errors.documento)"
            :error-message="hasError(factura.errors.documento) ? factura.errors.documento[0] : ''"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <InputProvider
            v-model="factura.total_documento"
            label="Total:"
            type="text"
            inputmode="decimal"
            :format-thousands="true"
            :max-decimals="2"
            :has-error="hasError(factura.errors.total_documento)"
            :error-message="hasError(factura.errors.total_documento) ? factura.errors.total_documento[0] : ''"
          />
        </div>
      </div>
    </template>
    <template #footer>
      <ButtonProvider
        type="submit"
        variant="primary"
        :label="factura.id == null ? 'Crear' : 'Editar'"
        :icon="factura.id == null ? 'fa-plus' : 'fa-edit'"
      />
      <ButtonProvider
        variant="danger"
        label="Cancelar"
        icon="fa-times"
        data-dismiss="modal"
        @click="cancelar()"
      />
    </template>
  </ModalProvider>
</template>

<script>
import _ from "lodash";
import CommonService from "@/services/commons/CommonService";
import Notifications from "@/notifications/notifications";
import DynamicService from "@/services/commons/DynamicService";
import moment from "moment";
import { 
  InputDatePicker,
  InputProvider,
  ModalProvider,
  ButtonProvider
} from "@/components/atomic";

export default {
  components: {
    InputDatePicker,
    InputProvider,
    ModalProvider,
    ButtonProvider
  },
  data() {
    return {
      factura: {
        id: null,
        fecha_documento: null,
        serie: "",
        documento: "",
        total_documento: null,
        archivo: null,
        errors: {
          fecha_documento: [],
          serie: [],
          documento: [],
          total_documento: [],
          archivo: [],
        },
      }
    };
  },
  computed: {
    formattedFechaDocumento() {
      if (this.factura.fecha_documento) {
        return moment(this.factura.fecha_documento).format('DD/MM/YYYY');
      }
      return '';
    }
  },
  props: {
    recepcion: {
      type: Object,
      required: true,
    },
    factura_id: {
      type: String,
      required: false,
    },
  },
  mounted() {
    let self = this;
    $("#modalFactura").on("hidden.bs.modal", function () {
      self.$emit("close");
    });
  },
  beforeDestroy() {
    $("#modalFactura").off("hidden.bs.modal");
  },
  watch: {
    factura_id: function () {
      let self = this;
      if (self.factura_id != null) {
        DynamicService.getById("wms", "facturas", self.factura_id).then(
          (response) => {
            self.factura = Object.assign(self.factura, response.data);
          }
        );
      } else {
        self.factura = {
          id: null,
          fecha_documento: null,
          serie: "",
          documento: "",
          total_documento: null,
          archivo: null,
          errors: {
            fecha_documento: [],
            serie: [],
            documento: [],
            total_documento: [],
            archivo: [],
          },
        };
      }
    },
  },
  methods: {
    cleanDataFactura() {
      let self = this;
      self.factura.id = null;
      self.factura.fecha_documento = null;
      self.factura.serie = "";
      self.factura.documento = "";
      self.factura.fecha_documento = null;
      self.factura.total_documento = null;
      self.factura.errors = {
        fecha_documento: [],
        serie: [],
        documento: [],
        total_documento: [],
        archivo: [],
      };
    },
    hasError(errorArray) {
      return errorArray && errorArray.length > 0;
    },
    cancelar() {
      let self = this;
      self.cleanDataFactura();
    },
    deshacerFecha() {
      this.factura.fecha_documento = null;
    },
    agregarFactura() {
      let self = this;
      
      // Limpiar errores previos antes de enviar
      self.factura.errors = {
        fecha_documento: [],
        serie: [],
        documento: [],
        total_documento: [],
        archivo: [],
      };

      // Construir payload limpio con solo los campos editables y necesarios
      let params = {
        fecha_documento: self.factura.fecha_documento,
        serie: self.factura.serie ? self.factura.serie.trim() : "",
        documento: self.factura.documento ? self.factura.documento.trim() : "",
        total_documento: self.factura.total_documento,
      };

      if (self.factura.id) {
        params.id = self.factura.id;
      }

      // Resolver ID de recepcion
      if (self.factura.recepcion) {
        params.recepcion = typeof self.factura.recepcion === "object" && self.factura.recepcion !== null
          ? self.factura.recepcion.id
          : self.factura.recepcion;
      } else if (self.recepcion && self.recepcion.id) {
        params.recepcion = self.recepcion.id;
      }

      if (params.fecha_documento) {
        params.fecha_documento = moment(params.fecha_documento).format(
          "DD/MM/YYYY"
        );
      }

      if ("id" in params) {
        return DynamicService.save("wms", "facturas", params)
          .then((res) => {
            self.cleanDataFactura();
            this.$emit("refresh", {});
          })
          .catch((error) => {
            if (error && error.response && error.response.data) {
              self.factura.errors = Object.assign(
                {
                  fecha_documento: [],
                  serie: [],
                  documento: [],
                  total_documento: [],
                },
                error.response.data
              );
              if ("detail" in error.response.data) {
                Notifications.alert.error(
                  "Abrir Transaccion",
                  error.response.data.detail
                );
              }
              if ("non_field_errors" in error.response.data) {
                Notifications.alert.error(
                  "Crear Factura",
                  error.response.data.non_field_errors[0]
                );
              }
            }
            throw error; // Lanzamos el error para que el modal NO se cierre
          });
      } else {
        return DynamicService.postAction(
          "wms",
          "recepcion",
          self.recepcion.id,
          "agregar_factura",
          params
        )
          .then((res) => {
            self.cleanDataFactura();
            this.$emit("refresh", {});
          })
          .catch((error) => {
            if (error && error.response && error.response.data) {
              self.factura.errors = Object.assign(
                {
                  fecha_documento: [],
                  serie: [],
                  documento: [],
                  total_documento: [],
                },
                error.response.data
              );
              if ("detail" in error.response.data) {
                Notifications.alert.error(
                  "Abrir Transaccion",
                  error.response.data.detail
                );
              }
              if ("non_field_errors" in error.response.data) {
                Notifications.alert.error(
                  "Crear Factura",
                  error.response.data.non_field_errors[0]
                );
              }
            }
            throw error; // Lanzamos el error para que el modal NO se cierre
          });
      }
    },
  },
};
</script>
